import ApiServiceBase from "./apiServiceBase.js";
import Config from "../config.js";

class ListAPI extends ApiServiceBase {
  constructor() {
    super();
    this.baseTVUrl = Config.services.api_tv.url;
    this.baseRadioUrl = Config.services.api_radio.url;
  }

  getTV(test, priority, callback, errorCallback) {
    this.getFromUrl(
      this.baseTVUrl + test + ".json",
      (responseJson) => {
        const response = responseJson;
        if (response) {
          //console.log(response);
          callback(response);
        }
      },
      (errorJson) => {
        const error = errorJson;
        if (error) {
          console.log(error);
          errorCallback(error);
        }
      },
      priority
    );
  }

  getRadio(test, priority, callback, errorCallback) {
    this.getFromUrl(
      this.baseRadioUrl + test + ".json",
      (responseJson) => {
        const response = responseJson;
        if (response) {
          //console.log(response);
          callback(response);
        }
      },
      (errorJson) => {
        const error = errorJson;
        if (error) {
          console.log(error);
          errorCallback(error);
        }
      },
      priority
    );
  }
}

export default new ListAPI();
